import { styled } from '@mui/material';
import { colors } from '../theme/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const Root = styled('div')(({
  ownerState: {
    active,
    completed
  }
}) => ({
  backgroundColor: active || completed ? colors.secondary.dark : colors.oriGrey.A200,
  zIndex: 1,
  fontSize: 18,
  fontWeight: 'bold',
  color: colors.primary.contrastText,
  width: 38,
  height: 38,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center'
}));
export default function StepLabelComponent({
  completed,
  active,
  icon
}) {
  return /*#__PURE__*/_jsx(Root, {
    className: "MuiOriStepLabelComponent",
    ownerState: {
      completed,
      active
    },
    children: icon
  });
}